module.exports = __webpack_public_path__ + "img/logo_secondary-white.3a731ba0.svg";